import React from 'react';
import { formatNumber2 } from "../../../../utils/currencyFormat";
import { getDate } from "../../../../utils/formatDate";
const PhieuInDanhSachNo = React.forwardRef((props, ref) => {
    const { listHopDong } = props;
    const renderTableData = () => {
        const tinhTrangStyleMap = {
            'Nợ xấu': { color: '#c0392b' },
            'Nợ rủi ro': { color: '#dd6308' },
            'Nợ R2': { color: '#fd7e14' },
            'Nợ R3': { color: '#dc3545' },
        };
        if (listHopDong && listHopDong.List && listHopDong.List.length > 0) {
            return listHopDong.List.map((hd, index) => {
                let statusStyle = {};
                if (hd.TinhTrang && hd.TinhTrang.startsWith('Bình thường')) {
                    statusStyle = { color: '#006266' };
                } else {
                    statusStyle = tinhTrangStyleMap[hd.TinhTrang] || {};
                }
                const cellStyle = { border: "1px solid #EEE", padding: "10px 5px", verticalAlign: "top", fontSize: "10pt" };
                const centerCellStyle = { ...cellStyle, textAlign: "center" };
                const rightCellStyle = { ...cellStyle, textAlign: "right" };

                return (
                    <tr key={hd.ChoVayID || index}>
                        <td style={centerCellStyle}>{hd.STT || index + 1}</td>
                        <td style={{ color: "#00B69B", ...centerCellStyle }}>{hd.MaHopDong}</td>
                        <td style={{ color: "#00B69B", ...centerCellStyle }}>{hd.TenKhachHang}</td>
                        <td style={centerCellStyle}>
                            <div>{hd.NgayVay ? getDate(hd.NgayVay) : ''}</div>
                            <div>{hd.NgayTra ? getDate(hd.NgayTra) : ''}</div>
                        </td>
                        <td style={rightCellStyle}>
                            <div className="red text-right">{formatNumber2(hd.SoTienVay)}</div>
                            <div style={{ fontSize: '9pt', color: '#dd6308' }}>{hd.LaiSuat}</div>
                        </td>
                        <td style={rightCellStyle} className="red text-right">{formatNumber2(hd.SoTienDaTra)}</td>
                        <td style={rightCellStyle} className="red text-right">{formatNumber2(hd.SoTienThanhToan)}</td>
                        <td style={centerCellStyle}>
                            <div><b>{hd.QuaHan} Ngày</b></div>
                            {hd.FilteredNotes && <div style={{ fontSize: '9pt' }}>Ghi chú: {hd.FilteredNotes}</div>}
                            {hd.FilteredExtensions && <div style={{ fontSize: '9pt' }}>Gia hạn: {hd.FilteredExtensions}</div>}
                        </td>
                        <td style={{ ...cellStyle, ...statusStyle }}>{hd.TinhTrang}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="9" style={{ border: "1px solid #EEE", padding: "5px", textAlign: 'center' }}>Không có dữ liệu.</td>
                </tr>
            );
        }
    };
    const headerCellStyle = { border: "1px solid #EEE", padding: "5px", fontWeight: "bold", color: "#000000", verticalAlign: "middle", textAlign: "center", fontSize: "10pt" };
    return (
        <div ref={ref} style={{ fontSize: "10pt", color: "#000000" }}>
            <table style={{ width: "90%", margin: "0 auto" }}>
                <tbody>
                    <tr>
                        <td style={{ textAlign: "center", width: "100%", fontWeight: "bold", fontSize: "18px", color: "#000000", padding: "10px 0 20px 0", textTransform: "uppercase" }}>
                            BÁO CÁO DANH SÁCH HỢP ĐỒNG
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px", fontSize: "10pt" }}>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #EEE", color: "#000000", marginTop: "10px" }}>
                    <tr>
                        <th style={headerCellStyle}>
                            <p className="color-do-bold mt-1" style={{ fontSize: "10pt" }}>
                                STT
                                <br />
                                [{listHopDong.iTotal}]</p>
                        </th>
                        <th style={headerCellStyle}>Mã hợp đồng</th>
                        <th style={headerCellStyle}>Tên khách hàng</th>
                        <th style={headerCellStyle}>Thời gian vay</th>
                        <th style={headerCellStyle}>
                            <p className="color-do-bold mt-1">Số tiền vay <br /> [{formatNumber2(listHopDong.TotalSoTienVay)}]</p>
                        </th>
                        <th style={headerCellStyle}>
                            <p className="color-do-bold mt-1">Số tiền đã trả <br /> [{formatNumber2(listHopDong.TotalSoTienDaTra)}]</p>
                        </th>
                        <th style={headerCellStyle}>
                            <p className="color-do-bold mt-1">Số tiền thanh toán <br /> [{formatNumber2(listHopDong.TotalSoTienThanhToan)}]</p>
                        </th>
                        <th style={{ ...headerCellStyle, width: "100px" }}>Quá hạn</th>
                        <th style={headerCellStyle}>Tình trạng</th>
                    </tr>
                    {renderTableData()}
            </table>
        </div>
    );
});
export default PhieuInDanhSachNo;